<template lang="pug">
    div(
        class="_mdls _d2 _con",
        :class="{ _v: visible && !occluded, _d2n: nested, ['_p'+actual]: true, ['_a'+align]: true }",
        :dir="direction",
        @mousedown.prevent="")
        ib-pick-date(
            ref="pick",
            class="_mdlsdef compact",
            wheel,
            :value="value",
            :min="min",
            :max="max",
            :distant="distant",
            :tabindex="null",
            @input="input")
</template>

<script>
    import anchored from '../private/anchored';


    /**
     * TODO: Call ib-pick-date directly using ib-modeless-dialog when available
     */
    export default {
        name: 'ib-field-date-pick',

        mixins: [
            anchored
        ],

        props: {
            value: String,
            min: String,
            max: String,
            distant: Boolean
        },

        computed: {
            direction() {
                const app = this.$root.__app;
                return app ? app.direction : 'ltr';
            }
        },

        watch: {
            value(to, from) {
                if (from == null && to != null) {
                    this.$refs.pick.setPage(0);
                }
            }
        },

        methods: {
            onOpen() {
                let page = this.distant && !this.value ? 2 : 0;
                if (page != this.page) {
                    this.$refs.pick.setPage(page);
                }
            },

            input(value) {
                this.close();
                this.$emit('input', value);
            }
        }
    }
</script>
